import React from "react";
import {Category, TypeForm} from "../types";
import {FiEdit} from "react-icons/fi";
import {FaTrash} from "react-icons/fa";
import {handleDelete} from "../utils/handleDeleteClick";
import "../styles/CategoryDetail.scss"
import {useModal} from "../Contexts/Modal";
import FormCategory from "./FormCategory";
import {useCategories} from "../hooks/useCategory";

export function CategoryDetail({category}: { category: Category }) {
    const {openModal, closeModal} = useModal()

    const {mutationDelete} = useCategories()


    return (
        <>
            <div className={"flex-row center"} id={"category-detail"}>
                <h2>Catégorie {category.category}</h2>
                <FiEdit className={"action edit"} onClick={() => {
                    openModal(<FormCategory category={category} typeForm={TypeForm.update}/>)
                }}/>
                <FaTrash className={"action delete"}
                         onClick={() => handleDelete(() => (mutationDelete.mutate({id: category.name})))}/>
            </div>
            <h3>Coefficient: {category.coefficient}</h3>
            <h3>{category.description}</h3>
        </>

    )
}